import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FAQ, faqData } from "../components/FAQ";
import { PeopleCrowd } from "../components/PeopleCrowd";
import { usePageMeta } from "../hooks/usePageMeta";

export default function FAQPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((q) => ({
      "@type": "Question",
      name: q.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  };

  usePageMeta({
    path: "/faq",
    title:
      "FAQ , Paid healthcare research: how it works | MediTalk",
    description:
      "Common questions about taking part in MediTalk paid healthcare research , who can join, how compensation works, time commitment, privacy and consent.",
    jsonLd,
  });

  return (
    <div>
      {/* Hero - DARK */}
      <section className="bg-[var(--dark-bg)] py-16 md:py-20">
        <div className="container-main">
          <div className="max-w-3xl">
            <span className="badge badge-terracotta mb-4">FAQ</span>
            <h1 className="text-4xl md:text-5xl font-['Outfit'] font-bold text-white leading-tight mb-6">
              Frequently Asked Questions
            </h1>
            <p className="text-lg text-[var(--gray-light)] leading-relaxed">
              Find answers to common questions about participating in our healthcare research studies.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content - LIGHT */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <FAQ />
          </div>
        </div>
      </section>

      {/* CTA - DARK */}
      <section className="py-16 md:py-20 bg-[var(--dark-bg)]">
        <div className="container-main text-center">
          <h2 className="text-2xl md:text-3xl font-['Outfit'] font-bold text-white mb-4">
            Still have questions?
          </h2>
          <p className="text-[var(--gray-light)] max-w-xl mx-auto mb-8">
            We're here to help. Reach out to our team for personalized support.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@medicysltd.co.uk"
              className="btn-primary"
              data-testid="faq-contact-btn"
            >
              Contact Us
            </a>
            <Link
              to="/patient/sign-up"
              className="btn-secondary flex items-center justify-center gap-2"
              data-testid="faq-join-btn"
            >
              Join Community
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* People Row - LIGHT */}
      <section className="bg-white py-8">
        <PeopleCrowd />
      </section>
    </div>
  );
}
